export const PERMISSIONS = [
  'viewDMS',
  'viewDMS.viewWish',
  'viewDMS.viewGive',
  'viewDMS.viewShop',
  'viewDMS.viewBlog',
  'viewDMS.viewBookADesk',
  'viewDMS.viewWeeklyNuggets',
  'viewDMS.viewWallOfFame',
  'viewDMS.viewAbsenceTracker',
  'viewDreamix',
  'viewVacation',
  'viewVacation.manageMyPendingRequests',
  'viewVacation.manageOtherPendingRequests',
  'viewVacation.createAbsenceRequest',
  'viewVacation.submitProxyRequests',
  'viewVacation.createHolidayWorkingRequest',
  'viewVacation.viewMyCalendar',
  'viewAdmin',
  'viewAdmin.viewRolesAndPermissions',
  'viewAdmin.viewRolesAndPermissions.viewRoles',
  'viewAdmin.viewRolesAndPermissions.viewRoles.createRole',
  'viewAdmin.viewRolesAndPermissions.viewRoles.editRole',
  'viewAdmin.viewRolesAndPermissions.viewRoles.deleteRole',
  'viewAdmin.viewRolesAndPermissions.viewPermissions',
  'viewAdmin.viewRolesAndPermissions.viewPermissions.editPermission',
  'viewAdmin.viewRolesAndPermissions.viewUserPermissions',
  'viewAdmin.viewRolesAndPermissions.viewUserPermissions.editUserPermissions',
  'viewAdmin.viewEvents',
  'viewAdmin.viewEvents.createEvent',
  'viewAdmin.viewEvents.viewActiveEvents',
  'viewAdmin.viewEvents.viewUpcomingEvents',
  'viewAdmin.viewEvents.viewPastEvents',
  'viewAdmin.viewEvents.viewDeletedEvents',
  'viewAdmin.viewEvents.viewActiveEvents.editActiveEvent',
  'viewAdmin.viewEvents.viewActiveEvents.deleteActiveEvent',
  'viewAdmin.viewEvents.viewActiveEvents.reorderActiveEvent',
  'viewAdmin.viewEvents.viewUpcomingEvents.editUpcomingEvent',
  'viewAdmin.viewEvents.viewUpcomingEvents.deleteUpcomingEvent',
  'viewAdmin.viewEvents.viewPastEvents.editPastEvent',
  'viewAdmin.viewEvents.viewPastEvents.deletePastEvent',
  'viewAdmin.viewEvents.viewDeletedEvents.editDeletedEvent',
  'viewAdmin.viewEvents.viewDeletedEvents.activateDeletedEvent',
  'viewAdmin.viewRequests',
  'viewAdmin.viewEditRequests',
  'viewAdmin.viewEditRequests.declineRequest',
  'viewAdmin.viewEditRequests.editPeriod',
  'viewAdmin.viewEditRequests.editVacationType',
  'viewAdmin.viewEditRequests.editCompensationType',
  'viewAdmin.viewOfficeSpace',
  'viewAdmin.viewOfficeSpace.createLabel',
  'viewAdmin.viewOfficeSpace.createDesk',
  'viewAdmin.viewOfficeSpace.editLabel',
  'viewAdmin.viewOfficeSpace.deleteLabel',
  'viewAdmin.viewOfficeSpace.editDesk',
  'viewAdmin.viewOfficeSpace.deleteDesk',
  'viewAdmin.viewOfficeSpace.createFloorPlan',
  'viewAdmin.viewOfficeSpace.editFloorPlan',
  'viewAdmin.viewOfficeSpace.deleteFloorPlan',
  'viewAdmin.viewOfficeSpace.manageBookings',
  'viewAdmin.viewOfficeSpace.manageReservations',
  'viewAdmin.viewReports',
  'viewAdmin.viewReports.viewOvertimesReport',
  'viewAdmin.viewReports.viewReimbursementsReport',
  'viewAdmin.viewReports.viewLoggedTimeReport',
  'viewAdmin.viewReports.viewNotificationManagement',
  'viewAdmin.viewReports.deleteLoggedTimeReport',
  'viewAdmin.viewReports.viewDaysLeftReport',
  'viewAdmin.viewReports.viewUtilizationRatesReport',
  'viewAdmin.viewReports.viewHeadcountsReport',
  'viewAdmin.viewReports.viewWorkdaysReport',
  'viewAdmin.viewReports.viewProbationReport',
  'viewAdmin.viewReports.viewDreamixBirthdayReport',
  'viewAdmin.viewReports.viewEmploymentHistoryReport',
  'viewAdmin.viewReports.viewGenderDiversityReport',
  'viewAdmin.viewReports.viewSkillsAndCertificatesReport',
  'viewAdmin.viewProjects',
  'viewAdmin.viewProjects.createProject',
  'viewAdmin.viewProjects.editProject',
  'viewAdmin.viewProjects.deleteProject',
  'viewAdmin.viewProjects.archiveProject',
  'viewAdmin.viewTeam',
  'viewAdmin.viewTeam.createUserProfile',
  'viewAdmin.viewTeam.editUserProfile',
  'viewAdmin.viewTeam.editUserProfile.editUserProjectHistory',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewContractPosition',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewContractPosition.editContractPosition',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewDreamixBirthday',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewDreamixBirthday.editDreamixBirthday',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewEndDate',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewEndDate.editEndDate',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewEndOfProbation',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewEndOfProbation.editEndOfProbation',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewOtherPaidLeaveLeft',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewOtherPaidLeaveLeft.editOtherPaidLeaveLeft',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewStartDate',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewStartDate.editStartDate',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewVacationDaysLeft',
  'viewAdmin.viewTeam.editUserProfile.viewCompanyDetails.viewVacationDaysLeft.editVacationDaysLeft',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewAddress',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewAddress.editAddress',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewCity',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewCity.editCity',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewCountryName',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewCountryName.editCountryName',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewEmail',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewNotes',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewNotes.editNotes',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewPersonalEmail',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewPersonalEmail.editPersonalEmail',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewPhone',
  'viewAdmin.viewTeam.editUserProfile.viewContactDetails.viewPhone.editPhone',
  'viewAdmin.viewTeam.editUserProfile.viewOracleDetails',
  'viewAdmin.viewTeam.editUserProfile.viewOracleDetails.viewOracleDepartment',
  'viewAdmin.viewTeam.editUserProfile.viewOracleDetails.viewOracleDepartment.editOracleDepartment',
  'viewAdmin.viewTeam.editUserProfile.viewOracleDetails.viewOracleExternalId',
  'viewAdmin.viewTeam.editUserProfile.viewOracleDetails.viewOracleExternalId.editOracleExternalId',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewBirthday',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewBirthday.editBirthday',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewFirstName',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewFirstName.editFirstName',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewFirstNameEn',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewFirstNameEn.editFirstNameEn',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewGender',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewGender.editGender',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewLastName',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewLastName.editLastName',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewLastNameEn',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewLastNameEn.editLastNameEn',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewMiddleName',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewMiddleName.editMiddleName',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewMiddleNameEn',
  'viewAdmin.viewTeam.editUserProfile.viewPersonalDetails.viewMiddleNameEn.editMiddleNameEn',
  'viewAdmin.viewTeam.deleteUserProfile',
  'viewAdmin.viewAdministration',
  'viewAdmin.viewAdministration.viewCertificates',
  'viewAdmin.viewAdministration.viewCertificates.createCertificate',
  'viewAdmin.viewAdministration.viewCertificates.editCertificate',
  'viewAdmin.viewAdministration.viewCertificates.deleteCertificate',
  'viewAdmin.viewAdministration.viewPositions',
  'viewAdmin.viewAdministration.viewPositions.createPosition',
  'viewAdmin.viewAdministration.viewPositions.editPosition',
  'viewAdmin.viewAdministration.viewPositions.deletePosition',
  'viewAdmin.viewAdministration.viewSkills',
  'viewAdmin.viewAdministration.viewSkills.createSkill',
  'viewAdmin.viewAdministration.viewSkills.editSkill',
  'viewAdmin.viewAdministration.viewSkills.deleteSkill',
  'viewAdmin.viewAdministration.viewDomains',
  'viewAdmin.viewAdministration.viewDomains.createDomain',
  'viewAdmin.viewAdministration.viewDomains.editDomain',
  'viewAdmin.viewAdministration.viewDomains.deleteDomain',
  'viewAdmin.viewAdministration.viewReimbursementTypes',
  'viewAdmin.viewAdministration.viewReimbursementTypes.manageReimbursementTypes',
  'viewAdmin.viewAdministration.viewTravelReport',
  'viewAdmin.viewAdministration.viewTravelReport.editTravelRequest',
  'viewAdmin.viewAdministration.viewTravelReport.deleteTravelRequest',
  'viewAdmin.viewAdministration.viewTravelReport.uploadTravelRequestTemplate',
  'viewAdmin.viewAdministration.viewTravelReport.viewTravelRequestTemplates',
  'viewAdmin.viewFeedback',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks.viewQuestions',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks.viewSections',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks.viewQuestions.createQuestion',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks.viewQuestions.deleteQuestion',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks.viewSections.createSection',
  'viewAdmin.viewFeedback.viewAdminFeedbackQuestionBanks.viewSections.deleteSection',
  'viewAdmin.viewFeedback.viewAdminTemplates',
  'viewAdmin.viewFeedback.viewAdminTemplates.createTemplate',
  'viewAdmin.viewFeedback.viewAdminTemplates.editTemplate',
  'viewAdmin.viewFeedback.viewAdminTemplates.deleteTemplate',
  'viewAdmin.viewFeedback.viewAdminReviewCycles',
  'viewAdmin.viewFeedback.viewAdminReviewCycles.createReviewCycle',
  'viewAdmin.viewFeedback.viewAdminReviewCycles.deleteReviewCycle',
  'viewAdmin.viewFeedback.viewAdminReviewCycles.editReviewCycle',
  'viewAdmin.viewFeedback.viewAdminReviewCycles.startReviewCycle',
  'viewAdmin.viewFeedback.viewAdminReviewCycles.stopReviewCycle',
  'viewAdmin.viewPages',
  'viewAdmin.viewPages.createPage',
  'viewAdmin.viewPages.editPage',
  'viewAdmin.viewPages.deletePage',
  'viewAdmin.viewPages.reorderPage',
  'viewAdmin.viewHolidays',
  'viewAdmin.viewHolidays.createHoliday',
  'viewAdmin.viewHolidays.editHoliday',
  'viewAdmin.viewHolidays.deleteHoliday',
  'viewAdmin.viewDreamixBirthdays',
  'viewAdmin.viewLicenses',
  'viewAdmin.viewLicenses.createLicense',
  'viewAdmin.viewLicenses.editLicense',
  'viewAdmin.viewLicenses.deleteLicense',
  'viewAdmin.viewLicenses.downloadLicense',
  'viewAdmin.viewLicenses.viewAssociations',
  'viewAdmin.viewLicenses.revokeAssignment',
  'viewAdmin.viewReferrals',
  'viewAdmin.viewAchievements',
  'viewAdmin.viewAchievements.createAchievement',
  'viewAdmin.viewAchievements.editAchievement',
  'viewAdmin.viewAchievements.reorderAchievement',
  'viewAdmin.viewAchievements.deleteAchievement',
  'viewAdmin.viewAchievements.assignAchievement',
  'viewAdmin.viewAchievements.deleteAchievementAssignment',
  'viewAdmin.viewAchievements.viewAchievementTypes',
  'viewAdmin.viewAchievements.viewAchievementTypes.createAchievementType',
  'viewAdmin.viewAchievements.viewAchievementTypes.editAchievementType',
  'viewAdmin.viewAchievements.viewAchievementTypes.deleteAchievementType',
  'viewAdmin.viewScheduledJobs',
  'viewAdmin.viewSystemConfig',
  'viewAdmin.viewSystemConfig.createConfig',
  'viewAdmin.viewSystemConfig.editConfig',
  'viewAdmin.viewSystemConfig.deleteConfig',
  'viewUser',
  'viewUser.viewRequests',
  'viewUser.viewRequests.viewMyRequests',
  'viewUser.viewRequests.viewMyRequests.manageMyRequests',
  'viewUser.viewRequests.viewMyRequests.viewMyPDFRequest',
  'viewUser.viewRequests.viewReviewedRequests',
  'viewUser.viewRequests.viewEmployeeLeaves',
  'viewUser.viewRequests.viewEmployeeLeaves.editRequests',
  'viewUser.viewRequests.viewEmployeeLeaves.declineRequests',
  'viewUser.viewPerformance',
  'viewUser.viewPerformance.viewMyReviewCycles',
  'viewUser.viewPerformance.viewMyReviewCycles.viewMyPacket',
  'viewUser.viewPerformance.viewMyReviewCycles.manageMyTeamPackets',
  'viewUser.viewMyTimeLog',
  'viewUser.viewMyTimeLog.manageMyTimeLogs',
  'viewUser.viewMyOvertimes',
  'viewUser.viewMyOvertimes.manageMyOvertimes',
  'viewUser.viewMyBusinessTravelRequests',
  'viewUser.viewMyBusinessTravelRequests.manageMyBusinessTravelRequests',
  'viewUser.viewMyReimbursements',
  'viewUser.viewMyReimbursements.manageMyReimbursements',
  'viewUser.viewKnowBe4',
  'viewUser.viewKnowBe4.viewMyDashboard',
  'viewUser.viewKnowBe4.viewMyPhishingResults',
  'viewUser.viewKnowBe4.viewMyTrainingAssignments',
  'viewUser.viewKnowBe4.viewMyTeamRiskScore',
  'viewUser.viewMyUserProfileSettings',
  'viewUser.viewMyUserProfileSettings.manageMySkills',
  'viewUser.viewMyUserProfileSettings.manageMyCertificate',
  'viewUser.viewMyUserProfileSettings.editMyUserProfile',
  'viewITSupport',
  'viewLead',
  'viewLead.viewLeadLoggedTime',
  'viewLead.viewLeadProjects',
] as const;

export type Permission = (typeof PERMISSIONS)[number];
